import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render Gala Dinner section for FAQ Page
 */
const GalaDinnerSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="gala-dinner-section-component"
    >
      <AccordionV2
        testId="gala-dinner"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="What is the SCA Gala Dinner and what happens then?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 mt-2 px-6 py-4 pb-0">
          <p>
            The gala dinner is organised to announce and honour the winners of
            the various awards for that year.
          </p>

          <p>
            The gala dinner is a black tie affair and the evening proceedings
            are usually conducted “Oscar-style” where corporate leaders take
            turns to host the various awards and event, and even provide
            entertainment.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default GalaDinnerSection;
